import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchInvitations } from '@/api/invitations/invitationsApi';
import type { Invitation } from '@/api/invitations/invitationsApi.types';
import type { PaginatedResult } from '@/api/pagination.types';
import { ADMIN_LIST_PAGE_SIZE } from '@/constants/adminPagination';
import { INVITATIONS_QUERY_KEY } from '@/constants/queryKeys';

const PENDING_INVITATION_STATUS = 'pending';

export function usePendingInvitationsQuery(
  scopeCode: string,
  page: number
): UseQueryResult<PaginatedResult<Invitation>, Error> {
  return useQuery({
    queryKey: [...INVITATIONS_QUERY_KEY, scopeCode, PENDING_INVITATION_STATUS, page],
    queryFn: function loadPendingInvitations() {
      return fetchInvitations(page, ADMIN_LIST_PAGE_SIZE, scopeCode, PENDING_INVITATION_STATUS);
    },
    placeholderData: keepPreviousData,
  });
}
